<template>
    <main class="news all_posts single-match">
        <ul v-if="game" class="sm fixtures-si">
            <TeamResults2 :game="game" />
            <div class="bor23"></div>
            <TableNews :single="single" :fullScreen="fullScreen" :currentYear="currentYear" :home="game.home"
                :away="game.away" />

        </ul>
    </main>
    <footer v-if="load">
        <p>all rights reserved by Rossoneries 2024</p>
    </footer>
</template>

<script>
import TeamResults2 from '@/components/team/TeamResults2.vue'
import TableNews from '@/components/team/TableNews.vue'
export default {
    name: 'SingleMatchResult',
    inject: ['backendServer', 'currentHost'],
    components: { TeamResults2, TableNews },

    data() {
        return {
            load: false,
            game: null,
            currentYear: 'default',
            fullScreen: true,
            single: true
        }
    },

    mounted() {
        let id = window.location.href.split('/').pop();

        fetch(this.backendServer() + '/single-results/' + id, {
            method: "GET",
            credentials: "include"
        })
            .then((response) => response.json())
            .then((data) => {
                this.game = data[0];
                this.load = !this.load
                document.title = this.game.home + ' ' + this.game.ft + ' ' + this.game.away;

            });

    }
}
</script>

<style scoped>
li.sr {
    border-radius: none !important;
}

.bor23 {
    width: 100%;
    height: 2px;
    background-color: black;

}

ul.sm {
    width: 100% !important;
    margin: 0 !important;
}

main.single-match {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
</style>